<div class="flex gap-2 overflow-hidden">
    <!-- Left Section -->
    <p-card class="w-4/12 pr-0 ticket-left-container-card" [style]="{'padding-right': '0px', 'padding-left': '0px'}">
        <div class=" overflow-auto ticket-left-container" style="height: calc(92vh - 110px);" #scrollContainer>
            <!-- <div class=" pb-1 z-10">
                <h5>Recent Tickets</h5>
                <div style="position: relative;">
                    <input [style]="{'borderRadius': '15px'}" [(ngModel)]="searchText" type="text" pInputText
                        placeholder="Search" class="w-full mb-3 -mt-2 rounded-lg" />
                    <div class="filter-icon-container">
                        <i class="pi pi-filter-fill" style="font-size: 13px;" *ngIf="!searchText"></i>
                        <i class="pi pi-filter-slash cursor-pointer" style="font-size: 13px;" *ngIf="searchText"
                            (click)="searchText = ''"></i>
                    </div>
                </div>

                <hr style="margin: 0" />
            </div> -->
            <!-- <h5 class="font-bold mt-2 ">My Open Tickets (6)</h5> -->

            <div *ngFor="let ticket of tickets; let i = index" class="border-round mb-3">
                <div class="flex flex-col justify-content-between align-items-center border-2 border-solid border-gray-200 p-3 rounded-2xl gap-3 ticket-card"
                    [ngClass]="{'active-card': cardActiveIndex === i}" (click)="cardActiveIndex = i">
                    <div class="flex align-items-center gap-1">
                        <div>
                            <p-avatar label="{{ ticket.initials }}"
                                [style]="{ height: '30px', width: '30px', borderRadius: '50%' }" shape="circle"
                                class="mr-2"></p-avatar>
                        </div>
                        <div class="flex flex-row justify-between items-center w-full">
                            <div class="font-bold text-lg">{{ ticket.name }}</div>
                            <small>{{ ticket.time }}</small>
                        </div>
                    </div>
                    <div class="text-sm truncate-2-lines">{{ ticket.message }}</div>
                    <div class="mb-1">
                        <span class="text-sm font-medium ticket-chip"
                            [style.backgroundColor]="getStatusBackgroundColor(ticket.status)"
                            [style.color]="getStatusColor(ticket.status)">{{ ticket.status }}</span>

                        <span class="text-sm font-medium ticket-chip"
                            [style.backgroundColor]="getPriorityBackgroundColor(ticket.priority)"
                            [style.color]="getPriorityColor(ticket.priority)">{{ ticket.priority + ' priority' }}</span>
                    </div>
                </div>
            </div>

            <!-- Infinite scroll trigger -->
            <div infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="200"
                [infiniteScrollContainer]="scrollContainer" (scrolled)="loadMore()">
            </div>

            <!-- Spinner at bottom -->
            <div class="text-center p-3" *ngIf="isLoading">
                <i class="pi pi-spinner pi-spin text-xl"></i>
            </div>

        </div>
    </p-card>

    <!-- Middle Section -->
    <p-card class="w-8/12">
        <app-ticket-middle-view
         [ticket]="tickets[cardActiveIndex]"></app-ticket-middle-view>
    </p-card>
</div>